/* Carte Blanche 1:1 LPの演出。各セクションのルート要素 <ns-lp-section> が
   自分の中の .ns1-revealをIntersectionObserverで静かに表示する。
   さらにヒーロー見出し([data-ns-splittitle])は文字単位でスタガー表示する。
   - Custom Elementなのでテーマエディタのsection追加・再描画で自動的に再初期化(章5-6)
   - reduced-motion / エディタ編集中 / JS無効 では常に全表示(内容は絶対に消えない)
   - localStorage不使用・グローバル非汚染 */
(function () {
  'use strict';
  if (window.customElements && customElements.get('ns-lp-section')) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editing = window.Shopify && window.Shopify.designMode;

  class NsLpSection extends HTMLElement {
    connectedCallback() {
      // 動きを減らす設定 / エディタ編集中は演出せず全表示
      if (reduce || editing) return;
      try {
        var title = this.querySelector('[data-ns-splittitle]');
        var targets = this.querySelectorAll('.ns1-reveal');
        if (!targets.length && !title) return;
        this.setAttribute('data-ns-anim', '');

        // ヒーロー見出しの文字スタガー
        if (title) this._enhanceTitle(title);

        if (!targets.length) return;
        if (!('IntersectionObserver' in window)) {
          for (var i = 0; i < targets.length; i++) targets[i].classList.add('is-in');
          return;
        }
        this._io = new IntersectionObserver(function (entries, obs) {
          for (var j = 0; j < entries.length; j++) {
            if (entries[j].isIntersecting) {
              entries[j].target.classList.add('is-in');
              obs.unobserve(entries[j].target);
            }
          }
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
        for (var k = 0; k < targets.length; k++) this._io.observe(targets[k]);
      } catch (e) {
        this.removeAttribute('data-ns-anim'); // 失敗時は全表示に戻す
      }
    }

    // 見出しの各行を1文字ずつ <span> に割って、遅延をずらして立ち上げる
    _enhanceTitle(title) {
      try {
        if (title._nsSplit) return;
        title._nsSplit = true;
        var lines = title.querySelectorAll('.ns1-hero__line');
        var idx = 0;
        for (var i = 0; i < lines.length; i++) {
          var line = lines[i];
          var text = line.textContent;
          line.setAttribute('aria-label', text); // 読み上げ・SEOは行単位の文字列を保持
          line.textContent = '';
          for (var c = 0; c < text.length; c++) {
            var span = document.createElement('span');
            span.className = 'ns1-hero__ch';
            span.setAttribute('aria-hidden', 'true');
            span.textContent = text.charAt(c);
            span.style.transitionDelay = (0.35 + idx * 0.045).toFixed(3) + 's';
            line.appendChild(span);
            idx++;
          }
        }
        var lite = function () { title.classList.add('is-lit'); };
        // 初期transformを確実に適用してから点灯(2フレーム後)
        requestAnimationFrame(function () { requestAnimationFrame(lite); });
        // 保険: 何があっても最終的に必ず表示する
        setTimeout(lite, 1400);
      } catch (e) {
        title.classList.add('is-lit'); // 失敗してもアクセント等は表示
      }
    }

    disconnectedCallback() {
      if (this._io) { this._io.disconnect(); this._io = null; }
    }
  }

  if (window.customElements) customElements.define('ns-lp-section', NsLpSection);
})();
